<template>
  <section class="pa-section pa-section-login-stamp-card">
    <div class="logo-header">
      <LoginStampCardLogo />
    </div>

    <div class="date-box">
      <div class="year">
        <div>{{lastLoginedAt | getYear}}</div>
        <div class="bottom"></div>
      </div>
      <div class="divider">/</div>
      <div class="month">
        <div>{{lastLoginedAt | getMonth}}</div>
        <div class="bottom"></div>
      </div>
      <div class="divider">/</div>
      <div class="day">
        <div>{{lastLoginedAt | getDay}}</div>
        <div class="bottom"></div>
      </div>
    </div>

    <div class="comment-box">
      <p>上記日時に於いて塔経市帝電子異界接続法の定める所により、</p>
      <p>異世界への接続が行われたことを証する。</p>
    </div>

    <hr class="calender-divider" />

    <div class="stamp-calender">
      <div class="week" v-for="(week, index) in weeks" :key="index">
        <template v-for="(day, dayIndex) in week">
          <template v-if="day !== null">
            <template v-if="day.stamped === true">
              <div class="day day-stamped" :key="dayIndex">
                {{day.day}}
                <div class="stamped">續</div>
              </div>
            </template>
            <template v-else>
              <div class="day" :key="dayIndex">{{day.day}}</div>
            </template>
          </template>
          <template v-else>
            <div class="day" :key="dayIndex"></div>
          </template>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import CalendarArrayGenerateMixin from '@/components/Pages/Home/LoginStampCard/CalendarArrayGenerateMixin.js'

import LoginStampCardLogo from '@/components/Pages/Home/LoginStampCard/Images/LoginStampCardLogo.svg?inlineN'

import {GetMe}  from '@/graphql/queries/User.graphql'

import {GetCharacterLoginStamp} from '@/graphql/queries/Character.graphql'

export default {
  mixins : [
    CalendarArrayGenerateMixin
  ],

  components : {
    LoginStampCardLogo
  },

  data(){
    return {
      lastLoginedAt : null
    }
  },

  apollo : {
    me: {
      query: GetMe,
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    },

    characterLoginStampList : {
      query : GetCharacterLoginStamp,
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    }
  },

  watch : {
    me : {
      handler(data){
        if(typeof data === 'undefined') return;
        
        this.lastLoginedAt = data.primaryCharacter.stamp_card.last_logined_at;
        this.lastLoginedAt = this.$moment(this.lastLoginedAt);

        this.weeks = this.generateCalendar();
      }
    },

    characterLoginStampList : {
      handler(data){
        if(typeof data === 'undefined') return;
        
        this.attachStampedFlags(data);
      }
    }
  },

  filters : {
    getYear(value){
      if(value === null) return '';

      return value.format('YYYY');
    },

    getMonth(value){
      if(value === null) return '';

      return value.format('MM');
    },

    getDay(value){
      if(value === null) return '';

      return value.format('DD');
    },
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-section{
  &-login-stamp-card{
    padding-top:.5rem;

    .logo-header{
      margin:0 auto;
      text-align:center;

      svg{
        max-width:92%;

        .a, .c {
          fill: none;
        }

        .b {
          fill: #8a5a23;
        }
      }
    }

    .date-box{
      width:96%;
      margin:.5rem auto;
      background-color:#C8AD89;
      color:#534633;
      border-radius:4px;
      display: flex;
      flex-direction: row;
      font-size:2.2rem;
      line-height:3.2rem;
      text-align:center;
      align-items: center;
      justify-content: center;
      font-family:sans-serif;
      font-weight: bold;
    
      .year, .month, .day{
        position: relative;

        .bottom{
          position: absolute;
          top:calc(51% - .8px);
          left:0;
          border-top:2.4px solid #C8AD89;
          width:100%;
        }
      }
    }

    .comment-box{
      font-size:.8rem;
      text-align:center;

      @include until(375px) {
        font-size:.68rem;
      }
    }

    .calender-divider{
      width:96%;
      margin:.8rem auto;
      background-color:#C6AA89;
    }

    .stamp-calender{
      margin:0 .4rem .2rem;
      .week{
        margin:.3rem auto;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        .day{
          background-color:#C8AD89;
          color:#977A54;
          width:2.8rem;
          height:2.8rem;
          border-radius: 50%;
          font-size:2.1rem;
          line-height: 2.8rem;
          text-align:center;
          position:relative;
          &-stamped{
            color:#AA8D67;
          }

          .stamped{
            box-sizing: border-box;
            border:4px solid #7D4708;
            position: absolute;
            top:0;
            left:0;
            width:2.8rem;
            height:2.8rem;
            border-radius:50%;
            color:#7D4708;
            font-weight: bold;
            font-size:1.7rem;
            line-height:2.4rem;
          }
        }
      }
    }
  }
}
</style>